
















import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component({
  name: 'conciseCard'
})
export default class ConciseCard extends Vue {
}
